const ALLOWED_FEATUREBASE_HOSTS = ['griply.featurebase.app'];
const FEATUREBASE_JWT_ENDPOINT =
  'https://griply.featurebase.app/api/v1/auth/access/jwt';

export const isValidFeaturebaseUrl = (urlString: string): boolean => {
  try {
    const url = new URL(urlString);

    if (url.protocol !== 'https:') {
      return false;
    }

    if (!ALLOWED_FEATUREBASE_HOSTS.includes(url.hostname)) {
      return false;
    }

    return true;
  } catch {
    return false;
  }
};

export const constructFeaturebaseJwtUrl = (
  jwtToken: string,
  returnToUrl: string,
): string => {
  const params = new URLSearchParams({
    jwt: jwtToken,
    return_to: returnToUrl,
  });

  return `${FEATUREBASE_JWT_ENDPOINT}?${params.toString()}`;
};
